import { render } from "./inventarioglobal.vue?vue&type=template&id=3ad6fec4"
import script from "./inventarioglobal.vue?vue&type=script&lang=js"
export * from "./inventarioglobal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__